module.exports = __webpack_public_path__ + "static/media/post.0e74ecb8.jpg";